import { ILaya } from "../../ILaya";
import { AnimationStretchMode, FrameAnimation } from "../components/FrameAnimation";
import { Sprite } from "../display/Sprite";
import { Loader } from "../net/Loader";
import { AtlasResource } from "../resource/AtlasResource";
import { Texture } from "../resource/Texture";
export class HtmlImage {
    constructor() {
        this._v = 0;
        this.obj = new Sprite();
    }
    get element() {
        return this._element;
    }
    get width() {
        return this.obj.width;
    }
    get height() {
        return this.obj.height;
    }
    create(owner, element) {
        this._owner = owner;
        this._element = element;
        this._owner.objContainer.addChild(this.obj);
        let src = this._element.getAttrString("src");
        if (src)
            this.loadTexture(src);
    }
    loadTexture(src) {
        let width = this._element.getAttrInt("width", -1);
        let height = this._element.getAttrInt("height", -1);
        if (width != -1)
            this.obj.width = width;
        if (height != -1)
            this.obj.height = height;
        this._w = width;
        this._h = height;
        let res = Loader.getRes(src);
        if (res) {
            this.onLoaded(res, ++this._v);
        }
        else {
            let ver = ++this._v;
            ILaya.loader.load(src, { silent: true }).then(res => this.onLoaded(res, ver, true));
        }
    }
    onLoaded(res, ver, delayed) {
        if (!this._owner || this.obj.destroyed)
            return;
        if (ver != this._v)
            return;
        let obj = this.obj;
        let ani = this._ani;
        if (res instanceof Texture) {
            obj.texture = res;
            if (ani)
                ani.setAtlas(null);
            if (this._w == -1)
                obj.width = res.sourceWidth;
            if (this._h == -1)
                obj.height = res.sourceHeight;
        }
        else if (res instanceof AtlasResource) {
            obj.texture = null;
            if (!ani) {
                ani = this._ani = obj.addComponent(FrameAnimation);
                ani.stretchMode = AnimationStretchMode.Fill;
                ani.autoPlay = true;
                ani.loop = true;
            }
            ani.setAtlas(res);
            if (this._w == -1)
                obj.width = ani.width;
            if (this._h == -1)
                obj.height = ani.height;
        }
        else {
            obj.texture = null;
            if (ani)
                ani.setAtlas(null);
            if (this._w == -1)
                obj.width = 0;
            if (this._h == -1)
                obj.height = 0;
        }
        if (delayed)
            this._owner.refreshLayout();
    }
    pos(x, y) {
        this.obj.pos(x, y);
    }
    release() {
        this.obj.removeSelf();
        this.obj.offAll();
        this.obj.texture = null;
        if (this._ani)
            this._ani.setAtlas(null);
        this._owner = null;
        this._element = null;
        this._v++;
    }
    destroy() {
        this.obj.destroy();
    }
}
